import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "direction", "gap", "flexWrap", "align", "justifyContent", "componentRef"];
import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Flex = function Flex(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 0 : _ref$gap,
    flexWrap = _ref.flexWrap,
    align = _ref.align,
    justifyContent = _ref.justifyContent,
    componentRef = _ref.componentRef,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn('component', className),
    ref: componentRef,
    style: {
      flexDirection: direction,
      gap: "".concat(gap, "px"),
      flexWrap: flexWrap,
      alignItems: align,
      justifyContent: justifyContent
    }
  }, otherProps, {
    "data-t-id": "components-Flex"
  }), children);
};